import { render } from "./TheAlert.vue?vue&type=template&id=7e5b1eb2&scoped=true"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"

import "./TheAlert.vue?vue&type=style&index=0&id=7e5b1eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5b1eb2"]])

export default __exports__